import React from "react";
import {
  NoDataContainer,
  NoDataIcon,
  NoDataText,
  NoDataSubtext,
} from "./index.styled";
import StarIcon from "../../StarIcon";

const NoDataFound: React.FC = () => {
  return (
    <NoDataContainer>
      <NoDataIcon>
        <StarIcon size={72} color="#122243" filled={true} />
      </NoDataIcon>
      <NoDataText>לא נמצאו נתונים עבור המסנן הנבחר</NoDataText>
      <NoDataSubtext>
        נסה לשנות את המסננים או לבדוק שוב מאוחר יותר
      </NoDataSubtext>
    </NoDataContainer>
  );
};

export default NoDataFound;
